<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      unit="优惠券"
      edit-title
      id-key="RecordId"
      :data="data"
      :form-rules="rules"
      form-label-width="110px"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @opened="onOpened"
      @closed="onClosed"
      @saved="onSaved"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="优惠券名称" prop="CouponName">
              <el-input v-model="data.CouponName" placeholder="请输入优惠券名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="CouponType">
              <el-select
                size="mini"
                style="width:100%"
                v-model="data.CouponType"
                placeholder="请选择类型"
              >
                <el-option label="满减" :value="1"></el-option>
                <el-option label="抵用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="封面图片" prop="CouponCover">
              <single-pic-upload
                v-model="data.CouponCover"
                type="PhotoAddress"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="面值" prop="FaceValue">
              <el-input v-model="data.FaceValue" type="numer" placeholder="请输入金额">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.CouponType==1">
            <el-form-item label="使用条件" prop="LeastAmount">
              <el-input v-model="data.LeastAmount" type="number" placeholder="请输入金额">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效期开始" prop="StartDate">
              <el-date-picker
                size="mini"
                v-model="data.StartDate"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期截止" prop="EndDate">
              <el-date-picker
                size="mini"
                v-model="data.EndDate"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="到账方式" prop="AccountWay">
              <el-select size="mini" v-model="data.AccountWay" placeholder="请选择到账方式">
                <el-option label="点击领取" :value="0"></el-option>
                <el-option label="自动到账" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发放数量" prop="SendNumber">
              <el-input v-model="data.SendNumber" type="number" v-int placeholder="请输入发放数量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="padding: 10px;text-align: center;border-top: 1px solid #e4e7ed;">
          <el-button v-if="canEdit"  size="mini" type="primary" @click="save">保 存</el-button>
          <el-button size="mini" style="margin-left: 20px;" @click="close">关 闭</el-button>
        </div>
        <el-tabs v-model="tabName" @tab-click="onTabClick" type="card">
          <el-tab-pane label="手动发放" name="manual">
            <manual ref="manual" />
          </el-tab-pane>
          <el-tab-pane label="自动发放" name="autoList">
            <auto-list ref="autoList">
              <el-table-column slot="column" align="center" fixed="right" width="80px">
                <template slot="header">
                  <i class="el-icon-circle-plus-outline add-icon" @click="add"></i>
                </template>
                <template slot-scope="{row,$index}">
                  <el-button icon="el-icon-edit" type="text" @click="edit(row)"></el-button>
                  <el-button icon="el-icon-delete" type="text" @click="del(row,$index)"></el-button>
                </template>
              </el-table-column>
            </auto-list>
          </el-tab-pane>
          <el-tab-pane label="使用记录" name="useLog" v-if="data.RecordId!=0">
            <use-log ref="useLog" />
          </el-tab-pane>
        </el-tabs>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import manual from "./manual";
import autoList from "./auto/list";
import useLog from "./useLog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    manual,
    autoList,
    useLog,
    singlePicUpload
  },
  data() {
    return {
      api: require("@/api/sale/coupon").default,
      data: {
        RecordId: 0,
        CouponName: "",
        CouponType: null, //类型 - 0:抵用 1:满减
        FaceValue: null, //面值 - 元
        LeastAmount: 0, //使用条件 - 元
        StartDate: null,
        EndDate: null,
        AccountWay: null, //到账方式 - 0:点击领取 1:自动到账
        SendNumber: null, //发放数量
        State: 1, //状态 - 0:停用 1:正常
        CouponCover: "",
        AutoIds: [],
      },
      uploadUrl: "/api/Common/UploadPicture",
      tabName: "manual",
      canEdit: false,
      rules: {
        CouponName: [{ required: true, message: "优惠券名称不能为空" }],
        CouponType: [{ required: true, message: "优惠券类型不能为空" }],
        FaceValue: [{ required: true, message: "面值不能为空" }],
        LeastAmount: [{ required: true, message: "使用条件不能为空" }],
        StartDate: [{ required: true, message: "有效期开始不能为空" }],
        EndDate: [{ required: true, message: "有效期截止不能为空" }],
        AccountWay: [{ required: true, message: "到账方式不能为空" }],
        SendNumber: [{ required: true, message: "发放数量不能为空" }],
        CouponCover: [{ required: true, message: "封面图片不能为空" }],
      },
    };
  },
  mounted() {
    this.canEdit = this.$permission.canEdit();
  },
  computed: {},
  methods: {
    onOpened() {
      this.$refs.manual.init();
    },
    onEditOpened(data) {
      
      // this.agApi.list({ id: this.data.AdjustId }).then((res) => {
      //   res.Data.forEach((x) => {
      //     this.AdjustGoods.push(x);
      //   });
      //   
      // });
      this.$refs.manual.setData(this.data.RecordId);
    },
    onBeforeSave() {
      this.data.AutoIds = this.$refs.autoList.data.map((x) => x.AutoId);
      


      return true;
    },
    onSaved() {
      
      this.$refs[this.tabName].setData(this.data.RecordId);
    },
    onTabClick() {
      this.$nextTick(() => {
        this.$refs[this.tabName].setData(this.data.RecordId);
      });
    },
    add() {
      this.$refs.autoList.add({
        CouponId: this.data.RecordId,
      });
    },
    edit(row) {
      this.$refs.autoList.edit(row);
    },
    del(row, index) {
      this.$refs.autoList.del(row, index);
    },
    onClosed() {
      if (this.$refs.useLog) this.$refs.useLog.clear();
      this.$refs.autoList.clear();
      this.$refs.manual.clear();
      this.tabName = "manual";
    },
  },
};
</script>